import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BOOKING_URL } from './siteConfig';
import './Navigation.css';

// Custom link component that scrolls to top on click
const ScrollToTopLink: React.FC<{to: string, children: React.ReactNode, className?: string}> = ({ to, children, className }) => {
  const handleClick = () => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  };

  return (
    <Link to={to} onClick={handleClick} className={className}>
      {children}
    </Link>
  );
};

// logoOnly: the logo and nothing else, for funnel pages like /tectonics.
// staysDark: navy header and light logo at every scroll position.
const Navigation: React.FC<{ logoOnly?: boolean; staysDark?: boolean }> = ({ logoOnly = false, staysDark = false }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    document.addEventListener('scroll', handleScroll);
    
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''} ${staysDark ? 'stays-dark' : ''}`}>
      <div className="nav-container">
        <ScrollToTopLink to="/" className="logo">
          <img
            src={require(scrolled && !staysDark ? './Images/Logo-black-text.png' : './Images/Logo-white-text-no-tagline.png')}
            alt="Cadence IO"
            className="logo-image"
          />
        </ScrollToTopLink>
        {!logoOnly && (
          <div className="nav-links">
            <ScrollToTopLink to="/about">About</ScrollToTopLink>
            <a
              href="https://app.cadenceio.com/auth/login"
            >
              Log In
            </a>
            <a 
              href={BOOKING_URL}
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-primary"
              style={{display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', width: '100%'}}>
              Book a call <span className="arrow">→</span>
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;